import { useTranslation } from 'react-i18next'
import { useFormikContext } from 'formik'

import { getManagerProfileOptions } from '../../../../../api'
import { EMPTY_LIST } from '../../../../../constants/common'
import { useScreen } from '../../../../../hooks'
import { getItemsFromIdwellApiResponse } from '../../../../../utils/api'
import { Checkbox, CHECKBOX_SIZE } from '../../../../Checkbox'
import { FormFieldSelectNG } from '../../../../Form'
import {
  FormikField,
  getFormikCheckboxFieldValueProps,
  getFormikFormFieldErrorProps,
} from '../../../../Formik'
import {
  SelectDropdownListFooter,
  SelectDropdownListHeader,
} from '../../../../Select'
import {
  toUserSelectItemsFromOption,
  USER_MULTI_SELECT_DROPDOWN_FLOATING_CONFIG_SELECT_ALL,
  UserMultiSelect,
} from '../../../../User'
import {
  BUILDING_GROUP_FORM_FIELD_NAME_MANAGERS,
  BUILDING_GROUP_FORM_FIELD_NAME_UPDATE_MANAGERS,
} from '../../BuildingGroupForm.constants'

import * as styles from './ManagersField.module.css'

function ManagersField(props) {
  const { t } = useTranslation()

  const { values } = useFormikContext()

  const { isMobileScreenSize } = useScreen() // TODO make same by css media instead of useScreen

  return (
    <div className={styles.managersField}>
      <FormikField
        {...props}
        multi
        Component={FormFieldSelectNG}
        Select={UserMultiSelect}
        controlProps={{
          borderless: !isMobileScreenSize,
          contentProps: {
            inputProps: {
              placeholder: t('BuildingGroup.ManagersFieldPlaceholderKey'),
            },
          },
        }}
        dropdownFloatingConfig={
          USER_MULTI_SELECT_DROPDOWN_FLOATING_CONFIG_SELECT_ALL
        }
        emptyValue={EMPTY_LIST}
        fieldComponentProps={{
          info: t('BuildingGroup.ManagersFieldInfoKey'),
          label: `${t('BuildingGroup.ManagersFieldLabelKey')}:`,
          shouldAdaptToMobileScreen: true,
        }}
        getData={getManagerProfileOptions}
        getDataItems={getItemsFromIdwellApiResponse}
        getErrorProps={getFormikFormFieldErrorProps}
        listProps={{
          Footer: SelectDropdownListFooter,
          Header: SelectDropdownListHeader,
        }}
        name={BUILDING_GROUP_FORM_FIELD_NAME_MANAGERS}
        tagsProps={{
          className: styles.managersFieldTags,
        }}
        toPreparedItems={toUserSelectItemsFromOption}
      />
      <FormikField
        Component={Checkbox}
        disabled={values[BUILDING_GROUP_FORM_FIELD_NAME_MANAGERS].length === 0}
        fieldComponentProps={{
          label: !isMobileScreenSize,
        }}
        getErrorProps={getFormikFormFieldErrorProps}
        getValueProps={getFormikCheckboxFieldValueProps}
        label={t('BuildingGroup.UpdateManagersFieldLabelKey')}
        labelClassName={styles.checkboxLabel}
        name={BUILDING_GROUP_FORM_FIELD_NAME_UPDATE_MANAGERS}
        size={CHECKBOX_SIZE.small}
      />
    </div>
  )
}

export default ManagersField
